export default __webpack_public_path__ + "static/media/logo_full_hard_light.af4797ca.svg";